var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 51.5,
    height: 51.5,
    rx: 25.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 51.5,
    height: 51.5,
    rx: 25.75,
    stroke: "#1FB16E",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5823 36.4627L17.9833 31.3467C17.1191 29.8493 16.6645 28.1508 16.6652 26.4107C16.6674 20.967 21.0974 16.5381 26.541 16.5381C29.1826 16.5392 31.6621 17.5674 33.5267 19.4336C35.3911 21.2997 36.4176 23.7803 36.4166 26.4186C36.4142 31.8622 31.9836 36.2917 26.541 36.2917C26.5406 36.2917 26.5411 36.2917 26.541 36.2917H26.5367C24.8839 36.2911 23.26 35.8765 21.8176 35.0898L16.5823 36.4627ZM22.06 33.3025L22.3599 33.4802C23.6199 34.228 25.0646 34.6235 26.5378 34.6243H26.541C31.065 34.6243 34.7471 30.9428 34.7491 26.418C34.7498 24.2252 33.8969 22.1633 32.3472 20.6123C30.7973 19.0612 28.7366 18.2066 26.544 18.2056C22.0163 18.2056 18.3343 21.8867 18.3326 26.4113C18.3319 27.9619 18.7657 29.4718 19.5875 30.7784L19.7828 31.089L18.9533 34.117L22.06 33.3025Z",
    fill: "#1FB16E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0727 22.2837C23.8879 21.8728 23.6932 21.8646 23.5173 21.8574C23.3735 21.8512 23.2088 21.8516 23.0445 21.8516C22.88 21.8516 22.6127 21.9135 22.3866 22.1604C22.1603 22.4073 21.5227 23.0042 21.5227 24.2184C21.5227 25.4326 22.4071 26.6058 22.5304 26.7706C22.6538 26.9352 24.2375 29.5064 26.7456 30.4955C28.8301 31.3176 29.2541 31.1541 29.7066 31.113C30.1591 31.0718 31.1665 30.516 31.3721 29.9398C31.5779 29.3636 31.5779 28.8699 31.5161 28.7665C31.4544 28.6638 31.2899 28.602 31.0431 28.4786C30.7964 28.3553 29.5833 27.7581 29.357 27.6759C29.1308 27.5935 28.9663 27.5525 28.8018 27.7996C28.6372 28.0463 28.1647 28.602 28.0207 28.7665C27.8767 28.9315 27.7327 28.9521 27.4859 28.8286C27.2392 28.7049 26.4444 28.4445 25.5016 27.6038C24.7681 26.9498 24.2727 26.142 24.1287 25.895C23.9849 25.6482 24.1264 25.5263 24.2372 25.3915C24.4368 25.1488 24.7716 24.7123 24.8538 24.5478C24.9361 24.383 24.895 24.239 24.8334 24.1155C24.7716 23.9921 24.292 22.7718 24.0727 22.2837Z",
    fill: "#1FB16E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp);
export default __webpack_public_path__ + "static/media/iconWhatsapp.65289dea062e413074fdc7f2eb93c694.svg";
export { ForwardRef as ReactComponent };